import {initMap} from "./map";
import  {buildAllDreams} from "./dream";


function init() {
    initMap();
    buildAllDreams();
}

window.init = init ;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 1
// module chunks = 0